<template>
    <CodiceFeanorView tool-module="scrypt" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
